import React from "react";
import { connect } from "react-redux";
import {
  fetchDeletedEmployees,
  restoreEmployee,
  fetchLeaves,
} from "../../../Redux/actions";
import MUIDataTable from "mui-datatables";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import { CircularProgress } from "@material-ui/core";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import RestoreEmployee from "@components/Modal/employees/RestoreEmployee";
import { ItemStyles } from "./styles";
import { formatDate } from "../../../utils/utils";

const Item = styled(Paper)(ItemStyles);

class DeactivateList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        {
          name: "_id",
          label: "Employee ID",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "contract_id",
          label: "Contract ID",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "created_at",
          label: "Created At",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "date_of_birth",
          label: "DOB",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "deleted_at",
          label: "Deleted At",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "updated_at",
          label: "Updated At",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "father_name",
          label: "Father Name",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "first_name",
          label: "First Name",
          options: {
            filter: true,
            sort: true,
          },
        },
        {
          name: "last_name",
          label: "Last Name",
          options: {
            filter: true,
            sort: true,
          },
        },
        {
          name: "isSoftDeleted",
          label: "Deleted",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "job_title",
          label: "Job Title",
          options: {
            filter: true,
            sort: true,
          },
        },
        {
          name: "account_No",
          label: "Account No",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "joining_date",
          label: "Joining Date",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "mobile_number",
          label: "Mobile Number",
          options: {
            filter: true,
            sort: true,
          },
        },
        {
          name: "national_id_number",
          label: "CNIC No",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "official_email",
          label: "Official Email",
          options: {
            filter: true,
            sort: true,
          },
        },
        {
          name: "permanent_address",
          label: "Permanent Address",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "personal_email",
          label: "Personal Email",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "residential_address",
          label: "Residential Address",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "residential_number",
          label: "Residential Number",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "salary",
          label: "Salary",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "contract",
          label: "Contract Status",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "yearly_quota",
          label: "Yearly Quota",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "availed_leaves",
          label: "Availed Leaves",
          options: {
            filter: true,
            sort: true,
            display: false,
          },
        },
        {
          name: "status",
          label: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <Stack direction="row">
                  <Item>
                    <RestoreFromTrashIcon
                      color="action"
                      cursor="pointer"
                      onClick={() => {
                        this.restoreModel(tableMeta.rowData[0]);
                      }}
                    />
                  </Item>
                </Stack>
              );
            },
          },
        },
      ],
      modalOpen: false,
      contractModal: false,
      closeModal: false,
      leaveModal: false,
      userData: "",
      contractData: "",
      employeesData: [],
      employeeData: "",
      isUpdateModal: false,
      isLoading: true,
      data: [],
      adjustmentModal: false,
      employee_id: null,
    };
  }

  fetchData = (data = []) => {
    return data.map((employee) => {
      const singleEmployeeLeaves = this.props.leaves
        .filter(
          (item) =>
            item.employee_id?._id === employee._id &&
            new Date(item.date_end).getFullYear() === new Date().getFullYear()
        )
        .reduce((pre, curr) => pre + curr.no_of_days, 0);
      return {
        ...employee,
        availed_leaves: -singleEmployeeLeaves,
        joining_date: formatDate(employee.joining_date),
        updated_at: formatDate(employee.updated_at),
        created_at: formatDate(employee.created_at),
        deleted_at: formatDate(employee.deleted_at),
        contract_id: employee?.contract_id?._id,
      };
    });
  };

  componentDidMount = async () => {
    if (
      this.props.deletedEmployees &&
      this.props.deletedEmployees.length === 0
    ) {
      await this.props.fetchDeletedEmployees();
    }
    if (!this.props.leaves.length) {
      await this.props.fetchLeaves();
    }
    this.setState({
      isLoading: false,
      data: this.fetchData(this.props.deletedEmployees),
    });
  };

  restoreModel = (employeeId) => {
    const { deletedEmployees } = this.props;
    this.setState({
      closeModal: true,
      employeeData: deletedEmployees.find(
        (employee) => employee._id === employeeId
      ),
    });
  };
  openCloseRestoreModel = async () => {
    this.setState({
      closeModal: !this.state.closeModal,
      data: this.fetchData(this.props.deletedEmployees),
    });
  };

  render() {
    return (
      <>
        {!this.state.isLoading ? (
          <div className="mui-data-table">
            <MUIDataTable
              title={"Deleted Employees"}
              options={{
                selectableRows: "none",
                rowHover: false,
                filter: false,
                print: false,
                download: false,
                responsive: "scroll",
                onColumnViewChange: (changedColumn, display) => {
                  let newCols = this.state.columns.slice();
                  for (let i = 0; i < newCols.length; i++) {
                    if (newCols[i].name === changedColumn) {
                      newCols[i].options.display =
                        display == "add" ? true : false;
                    }
                  }
                  this.setState({
                    columns: newCols,
                  });
                },
              }}
              data={this.state.data}
              columns={this.state.columns}
            />
          </div>
        ) : (
          <div className="LoaderWrapper">
            <CircularProgress color="primary" />
          </div>
        )}

        {this.state.closeModal && (
          <RestoreEmployee
            openModal={this.openCloseRestoreModel}
            employeeData={this.state.employeeData}
          />
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    deletedEmployees: state.deletedEmployees?.payload,
    success: state.employees?.length && state.employees[0].success,
    leaves: state.leaves?.payload,
  };
};

export default connect(mapStateToProps, {
  fetchDeletedEmployees,
  restoreEmployee,
  fetchLeaves,
})(DeactivateList);
